import React from 'react';
import { COLORS } from '../../constants';
import { AiOutlineHome } from 'react-icons/ai';
import { FaRobot } from 'react-icons/fa';
import { FaBullseye } from 'react-icons/fa';
import { FiSettings } from 'react-icons/fi';
import './Bottomnav.css';

const BottomNav = ({ active, onChange }) => {
  const items = [
    {
      id: 'dashboard',
      icon: <AiOutlineHome size={24} />,
      label: 'Home',
    },
    {
      id: 'bot',
      icon: <FaRobot size={24} />,
      label: 'Operar',
    },
    {
      id: 'goals',
      icon: <FaBullseye size={24} />,
      label: 'Metas',
    },
    {
      id: 'settings',
      icon: <FiSettings size={24} />,
      label: 'Ajustes',
    },
  ];

  return (
    <nav className="prisma-bottom-nav">
      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => onChange(item.id)}
          className={`nav-item ${active === item.id ? 'active' : ''}`}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;